<script setup>
import { ref, watch } from 'vue';
import { useNoteTypeStore } from '@/stores/useNoteTypeStore';
import debounce from 'lodash.debounce';

const store = useNoteTypeStore();
const search = ref(store.searchTerm);

// Debounced fetch com atraso de 400ms
const debouncedSearch = debounce(async () => {
  store.currentPage = 1;
  store.searchTerm = search.value;
  store.shouldForcePageOne = true;
  await store.fetchNoteTypesPaged(1, store.pageSize, store.searchTerm);
}, 400);

// Observa mudanças
watch(search, () => {
  debouncedSearch();
});
</script>

<template>
  <div class="search-input-wrapper">
    <div class="icon-wrapper">
      <svg
        aria-hidden="true"
        class="search-icon"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>

    <div class="search-text-input">
      <input
        v-model="search"
        type="text"
        id="simple-search"
        placeholder="Buscar categoria de nota..."
        class="search-input"
      />
    </div>
  </div>
</template>

<style scoped>
.search-icon {
  width: 1rem;
}

.search-input {
  height: 34px;
}

</style>
